import React from 'react'
import Modal from "react-modal";
import { motion } from "framer-motion";
import Loader from '../../containers/Loader';

const PaymentPopup = ({ transactionInProgress, setShowModal,showModal }) => {
  return (
    <Modal
      isOpen={showModal}
      //   onRequestClose={closeModal}
      contentLabel="Example Modal"
      className="custom-modal"
      overlayClassName="custom-modal-overlay"
    >
      {transactionInProgress ? (
        <>
          <h5>Processing Transaction... Please don't reload.</h5>
          <Loader />
        </>
      ) : (
        <div style={{textAlign:'center'}}>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 24 24"
            fill="green"
            width="66px"
            height="66px"
          >
            <path d="M0 0h24v24H0z" fill="none" />
            <path d="M12 0C5.37 0 0 5.37 0 12s5.37 12 12 12 12-5.37 12-12S18.63 0 12 0zm-1 17.93l-4.24-4.24 1.41-1.41 2.83 2.83 6.59-6.59 1.41 1.41L11 17.93z" />
          </svg>
          <h5 className='mt-2'>Payment Successful!</h5>
        </div>
      )}
      <div className="button-section"
      style={{paddingTop:'15px',display:'flex',justifyContent:'center',alignItems:'center'}}
      >
        <button
          onClick={() => setShowModal(false)}
          className="close-modal-button"
        >
          {"Close"}
        </button>
      </div>
    </Modal>
  );
};

export default PaymentPopup